import 'select2';
import WOW from 'wow.js'
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';
import './csr_game';

// Some JavaScript Here
$(document).ready(function(){

  //index sidebar's dropdown animation
  $('.drop').click(function(){
    if (window.innerWidth <= 1100) {
      $(this).siblings('.dropdown-menu, .header-menu-dropdown').slideToggle();
    }
  });

  var indexBanner = new Swiper('#indexBanner', {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: {
      delay: 5000,
    },
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  //static sidebar's dropdown animation
  $('.static-drop').click(function(){
    $('.static-dropdown-menu').slideToggle();
  });
  $('.left-nav-item > a').click(function(){
    event.preventDefault();
    $(this).parent().siblings().find('ul').slideUp();
    $(this).parent().find('ul').slideToggle();
    $(this).parent().addClass('open').siblings().removeClass('open');
  });

  //scroll to top animation
  $('.back-to-top').click(function(){
    $("html,body").animate({scrollTop: 0}, 1000);
  });

  //brand page tabpanel
  $('.nav-tabs li').click(function(){
    event.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
  });
  $('.content:first').show();
  $('.nav-tabs li:first').addClass('active');

  $('.tab-news').click(function(){
    event.preventDefault();
    $('.content-1').fadeIn(500).siblings().hide();
  });
  $('.tab-scuccess').click(function(){
    event.preventDefault();
    $('.content-2').fadeIn(500).siblings().hide();
  });
  $('.tab-technical').click(function(){
    event.preventDefault();
    $('.content-3').fadeIn(500).siblings().hide();
  });
  $('.tab-product').click(function(){
    event.preventDefault();
    $('.content-4').fadeIn(500).siblings().hide();
  });
  $('.tab-events').click(function(){
    event.preventDefault();
    $('.content-5').fadeIn(500).siblings().hide();
  });
  $('.tab-class').click(function(){
    event.preventDefault();
    $('.content-6').fadeIn(500).siblings().hide();
  });

  //brand static panel
  $('.panel-group > li > a').click(function(){
    event.preventDefault();
    // $(this).toggleClass('active');
    $(this).parent().siblings().find('ul').slideUp();
    $(this).parent().find('ul').slideToggle();
  });

  //wow.js animation plugin
  new WOW().init();

  //lightbox
  $('#open-modal').click(function(){
    $('#myModal').show();
  });
  $('#closeModal').click(function(){
    $('#myModal').css('display','none');
  });

  $('#sustainable_cancel').click(function(){
    $("#sustainable_popup").addClass('hide');
  });

  // accordion
  var activeAccordion = $('.accordion-item .accordion-main');
  $(activeAccordion).click(function(){
    $(this).toggleClass('active').siblings('.accordion-content').slideToggle(200);
    $(this).parent('.accordion-item').siblings('.accordion-item').find('.accordion-content').slideUp(200).siblings('.accordion-main').removeClass('active');
  });

  // index popup
  if (Cookies.get('popupLoad') === undefined) {
    $('#index_popup').find('.confirm').on('click', function() {
      $("#index_popup").addClass('close');
      Cookies.set('popupLoad', 'true');
    });
  } else {
    $('#index_popup').remove();
  }

  // cookie popup
  // consent=all（或舊值 true）：已同意且允許載入 GTM
  // consent=necessary：已同意但不載入 GTM
  const COOKIE_CONSENT_KEY = 'consent';
  const TRACKING_COOKIE_PREFIXES = ['_ga', '_gid', '_gat', '_gcl', '_gac', '_dc_gtm', '__hs', 'hubspotutk', '_fbp', '_fbc'];
  const allowAnalyticsConsent = function(value) {
    return value === 'true' || value === 'all';
  };
  const clearTrackingCookies = function() {
    const hostname = window.location.hostname;
    const rootDomain = hostname.replace(/^www\./, '');
    const domains = ['', hostname, '.' + hostname];
    if (rootDomain !== hostname) {
      domains.push(rootDomain, '.' + rootDomain);
    }
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie.split(';').forEach(function(cookie) {
      const name = cookie.split('=')[0].trim();
      const isTrackingCookie = TRACKING_COOKIE_PREFIXES.some(function(prefix) {
        return name.indexOf(prefix) === 0;
      });
      if (!name || !isTrackingCookie) {
        return;
      }
      domains.forEach(function(domain) {
        const domainAttr = domain ? '; domain=' + domain : '';
        [
          '',
          '; Secure',
          '; Secure; SameSite=Lax',
          '; Secure; SameSite=None'
        ].forEach(function(extra) {
          document.cookie = name + '=; Max-Age=0; expires=' + expires + '; path=/' + domainAttr + extra;
        });
      });
    });
  };
  const applyCookieConsent = function(allowAnalytics) {
    const $banner = $('#agreeCookie');
    $banner.addClass('approved');
    $('body').removeClass('is-cookie-consent-open');
    if (allowAnalytics) {
      $banner.attr('aria-hidden', 'true');
      Cookies.set(COOKIE_CONSENT_KEY, 'all');
    } else {
      $banner.attr('aria-hidden', 'false');
      Cookies.set(COOKIE_CONSENT_KEY, 'necessary');
      clearTrackingCookies();
    }
  };

  let $cookiePopupToggle = $('.cookie_popup_toggle');
  if ( $cookiePopupToggle.length > 0 ) {
    // popup toggle
    $('.cookie_popup_toggle').on('click', function() {
      $('#agreeCookie').addClass('is-behind-popup');
      $('#cookie_popup').addClass('active');
    });
    // popup - close btn
    $('#cookie_popup').find('.popup-close-btn').on('click', function() {
      $('#cookie_popup').removeClass('active');
      $('#agreeCookie').removeClass('is-behind-popup');
    });
    // popup - accept btn
    $('#cookie_popup').find('.confirm').on('click', function() {
      $(this).trigger('blur'); // 讓按鈕失去焦點, 避免無障礙屬性報錯
      $('#cookie_popup').removeClass('active');
      const allowAnalytics = $('#js-cookie-analytics').prop('checked');
      applyCookieConsent(allowAnalytics);
      if (!allowAnalytics) {
        window.location.reload();
      }
    });
  }

  // tabs nav & content
  if ( $('#js-cookie-nav-tabs').length != 0 ) {
    const $tabsNavItem = $('#js-cookie-nav-tabs').find('.cookie-nav-tabs-toggle');
    const $tabsContentWrap = $('#js-cookie-tab-content').find('.cookie-tab-pane');
    $tabsNavItem.on('click', function() {
      $tabsNavItem.removeClass('active');
      $(this).addClass('active');
      let targetContent = $(this).attr('data-target');
      $tabsContentWrap.removeClass('active');
      $(targetContent).addClass('active');
    });
  }

  /* 
    cookie 紀錄 (26/09/16 更新)
    網頁上的 cookie 訊息框容器改用 aria-hidden 屬性值控制是否載入第三方追蹤碼:
      1. 無 consent 紀錄時, 底欄「接受所有 Cookie」寫入 all；popup 確認仍依「分析／效能 Cookie」開關決定 all 或 necessary
      2. 舊值 consent=true 視為已允許分析, 維持載入 GTM
  */
  const savedConsent = Cookies.get(COOKIE_CONSENT_KEY);
  const onCookieSettingsPage = $('#cookie-settings').length > 0;
  if ( savedConsent === undefined ) {
    if ( onCookieSettingsPage ) {
      $('#agreeCookie').addClass('approved');
    } else {
      $('body').addClass('is-cookie-consent-open');
      $('#agreeCookie').find('.agree_cookie_btn').on('click', function() {
        $(this).trigger('blur'); // 讓按鈕失去焦點, 避免無障礙屬性報錯
        $('#js-cookie-analytics').prop('checked', true);
        applyCookieConsent(true);
      });
    }
  } else {
    applyCookieConsent(allowAnalyticsConsent(savedConsent));
  }

  const $pageAnalytics = $('#js-page-cookie-analytics');
  if ( $pageAnalytics.length > 0 ) {
    $pageAnalytics.prop('checked', allowAnalyticsConsent(savedConsent));
    $('.js-cookie-save').on('click', function() {
      $(this).trigger('blur');
      const allowAnalytics = $pageAnalytics.prop('checked');
      applyCookieConsent(allowAnalytics);
      if ( !allowAnalytics ) {
        window.location.reload();
      }
    });
    $('.js-cookie-accept-all').on('click', function() {
      $(this).trigger('blur');
      $pageAnalytics.prop('checked', true);
      applyCookieConsent(true);
    });
  }

  // 展開更多
  $('.show-more-btn').click(function(){
    $(this).parent('.hide-container').addClass('is-show');
  });

  // select 2
  const productSelect = document.getElementById('productSelect');
  if (productSelect) {
    $('#productSelect').select2({
      placeholder: "<%= t('select2.placeholder') %>",
      allowClear: true,
      minimumResultsForSearch: 0,
      dropdownCssClass: 'custom-product-select2-dropdown',
      // 客製化比對，從字首比對，讓下拉選單重新排序
      matcher: function(params, data) {
        // 使用者沒打字，就直接顯示所有選項
        if ($.trim(params.term) === '') {
          return data;
        }

        const term = params.term.toLowerCase();
        const text = (data.text || '').toLowerCase();

        // 完全沒有符合的話就忽略這選項
        if (text.indexOf(term) === -1) {
          return null;
        }

        // 判斷這個選項文字是不是「從 term 開頭」
        const matchStart = text.startsWith(term);
        // 開頭符合的排序權重是 1
        const sortPriority = matchStart ? 1 : 2;

        data.sortPriority = sortPriority;
        return data;
      },
      sorter: function(results) {
        // 開頭符合排在前面，中間才符合排後面
        return results.sort(function(a, b) {
          return (a.sortPriority || 2) - (b.sortPriority || 2);
        });
      }
    });
  }
  $('.js-example-basic-multiple').select2();

  $('#productSelect').on('change', function() {
    var selectedBrand = $(this).val();
    if (selectedBrand) {
      $('#productList .item').hide();
      $('#productList .item[data-brand="' + selectedBrand + '"]').show();
    } else {
      $('#productList .item').show();
    }
  });
  $('.select2-brand-solution-mobile').select2({
    placeholder: $('.select2-brand-solution-mobile').data('placeholder'),
    dropdownCssClass: 'custom-solution-select2-dropdown',
  });

  $('.select2-brand-solution-mobile').on('select2:select select2:unselect', function () {
    const $form = $(this).closest('form');
    const currentAction = $form.attr('action');
    if (!currentAction.includes('#brandSearchGroup')) {
      $form.attr('action', currentAction + '#brandSearchGroup');
    }
    setTimeout(function () {
      $form.trigger('submit');
    }, 100);
  });
  if (window.location.hash === '#brandSearchGroup') {
    const el = document.getElementById('brandSearchGroup');
    if (el) {
      const offset = 70;
      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  let lastWidth = window.innerWidth;
  $(window).on('resize', function () {
    const nowWidth = window.innerWidth;
    if (window.location.pathname === '/brands' && lastWidth <= 991 && nowWidth > 991) {
      const cleanPath = window.location.pathname;
      window.location.href = cleanPath; // 移除 ?q=... 等參數
    }
    lastWidth = nowWidth;
  });


  // micro365
  $('.tab[data-micro]').on('click', function () {
    var ID = $(this).data('micro');
    $(this).addClass('active').siblings().removeClass('active');
    $("#" + ID).addClass('active').siblings().removeClass('active');
  });

  // esg首頁 - 內容 tabs
  if ( $('#js-nav-tabs').length != 0 ) {
    const $tabsNavItem = $('#js-nav-tabs').find('.nav-tabs-toggle');
    const $tabsContentWrap = $('#js-tab-content').find('.tab-pane');

    // 切換分頁的共用函式:傳入目標分頁的按鈕元素(jQuery 物件)
    function activateEsgTab($targetToggle, shouldScroll) {
      if ($targetToggle.length === 0) return;

      $tabsNavItem.removeClass('active');
      $targetToggle.addClass('active');

      let targetContent = $targetToggle.attr('data-target');
      $tabsContentWrap.removeClass('active');
      $(targetContent).addClass('active');

      // 如果需要捲動,才捲動到該區塊(避免手動點擊分頁時畫面也跳動)
      if (shouldScroll) {
        const offset = 100; // 依 fixed header 高度自行調整
        const $section = $('.esg-categories-section');
        if ($section.length > 0) {
          const y = $section.offset().top - offset;
          $('html, body').animate({ scrollTop: y }, 500);
        }
      }
    }

    // 一般點擊分頁按鈕
    $tabsNavItem.on('click', function() {
      activateEsgTab($(this), false);
    });

    // 依網址 hash 自動切換分頁(從其他頁面點連結過來、或是重新整理時)
    function activateTabByHash() {
      const hash = window.location.hash; // 例如 "#environment"
      if (!hash) return;

      const $targetToggle = $tabsNavItem.filter(function() {
        return $(this).attr('data-target') === hash;
      });

      if ($targetToggle.length > 0) {
        activateEsgTab($targetToggle, true);
      }
    }

    // 頁面載入時執行一次
    activateTabByHash();

    // 如果使用者已經在 esg 頁面上、又點了帶 hash 的連結(不會整頁重新載入),也要能反應
    $(window).on('hashchange', activateTabByHash);
  }
  // esg首頁-主題輪播
  if ( $('.esg-topics-swiper-wrap').length > 0 ) {
    var esgTopicsSwiperGovernance = new Swiper("#esgTopicsSwiper-governance", {
      modules: [Navigation],  // 一定要加這行, 不然箭頭按鈕沒有功能
      watchOverflow: true,
      observer: true,        // 監聽 Swiper 容器自身的 DOM/樣式變化
      observeParents: true,  // 監聽父層容器的 DOM/樣式變化(例如 tab-pane 的 display 切換)
      slidesPerView: 1,
      spaceBetween: 34,
      navigation: {
        prevEl: ".esg-topics-swiper-wrap.governance .swiper-button-prev",
        nextEl: ".esg-topics-swiper-wrap.governance .swiper-button-next",
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 3,
        },
        1025: { // >= 1025px 時
          slidesPerView: 2,
        },
      },
    });

    var esgTopicsSwiperSocial = new Swiper("#esgTopicsSwiper-social", {
      modules: [Navigation],  // 一定要加這行, 不然箭頭按鈕沒有功能
      watchOverflow: true,
      observer: true,        // 監聽 Swiper 容器自身的 DOM/樣式變化
      observeParents: true,  // 監聽父層容器的 DOM/樣式變化(例如 tab-pane 的 display 切換)
      slidesPerView: 1,
      spaceBetween: 34,
      navigation: {
        prevEl: ".esg-topics-swiper-wrap.social .swiper-button-prev",
        nextEl: ".esg-topics-swiper-wrap.social .swiper-button-next",
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 3,
        },
        1025: { // >= 1025px 時
          slidesPerView: 2,
        },
      },
    });

    var esgTopicsSwiperEnvironment = new Swiper("#esgTopicsSwiper-environment", {
      modules: [Navigation],  // 一定要加這行, 不然箭頭按鈕沒有功能
      watchOverflow: true,
      observer: true,        // 監聽 Swiper 容器自身的 DOM/樣式變化
      observeParents: true,  // 監聽父層容器的 DOM/樣式變化(例如 tab-pane 的 display 切換)
      slidesPerView: 1,
      spaceBetween: 34,
      navigation: {
        prevEl: ".esg-topics-swiper-wrap.environment .swiper-button-prev",
        nextEl: ".esg-topics-swiper-wrap.environment .swiper-button-next",
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 3,
        },
        1025: { // >= 1025px 時
          slidesPerView: 2,
        },
      },
    });
  }
  // esg首頁-獎項輪播
  if ( $('.esg-awards-swiper-wrap').length > 0 ) {
    var esgAwardsSwiper = new Swiper("#esgAwardsSwiper", {
      modules: [Navigation, Autoplay],  // 一定要加這行, 不然箭頭按鈕沒有功能
      autoplay: {
        delay: 3000,
      },
      loop: true,
      watchOverflow: true,
      observer: true,        // 監聽 Swiper 容器自身的 DOM/樣式變化
      observeParents: true,  // 監聽父層容器的 DOM/樣式變化(例如 tab-pane 的 display 切換)
      slidesPerView: 1,
      spaceBetween: 40,
      navigation: {
        prevEl: ".esg-awards-swiper-wrap .swiper-button-prev",
        nextEl: ".esg-awards-swiper-wrap .swiper-button-next",
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 4,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
        },
      },
    });
  }
  // esg首頁-靜態連結搜尋下拉選單(select2)
  const staticLinkSelect = document.getElementById('staticLinkSelect');
  if (staticLinkSelect) {
    $('#staticLinkSelect').select2({
      placeholder: $('#staticLinkSelect').data('placeholder'),
      allowClear: true,
      minimumResultsForSearch: 0,
      dropdownCssClass: 'custom-product-select2-dropdown',
      // 客製化比對：從字首比對，讓下拉選單重新排序
      matcher: function (params, data) {
        // 使用者沒打字，就直接顯示所有選項
        if ($.trim(params.term) === '') {
          return data;
        }

        const term = params.term.toLowerCase();
        const text = (data.text || '').toLowerCase();

        // 完全沒有符合的話就忽略這選項
        if (text.indexOf(term) === -1) {
          return null;
        }

        // 判斷這個選項文字是不是「從 term 開頭」
        const matchStart = text.startsWith(term);
        // 開頭符合的排序權重是 1
        const sortPriority = matchStart ? 1 : 2;

        data.sortPriority = sortPriority;
        return data;
      },
      sorter: function (results) {
        // 開頭符合排在前面，中間才符合排後面
        return results.sort(function (a, b) {
          return (a.sortPriority || 2) - (b.sortPriority || 2);
        });
      }
    });

    // 選取選項後不做任何事，select2 會自動把文字顯示在框裡
    // （這裡故意不加 select2:select 事件監聽，交給下方按鈕統一處理）

    // 按下搜尋按鈕，才導頁到選中的 url
    $('#staticSearchBtn').on('click', function () {
      const url = $('#staticLinkSelect').val(); // value 就是我們塞進去的 url
      if (url) {
        window.location.href = url;
      }
    });
  }
})
$(document).on('select2:open', e => {
  const id = e.target.id;
  const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
  target.focus();
});
